import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import { useId } from 'react';
import ToggleUI from './ToggleUI';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BillingTermToggle = ({
  isAnnual,
  onToggle,
  labelMonthly,
  labelAnnual,
  ariaLabel,
  bestValueLabel,
  wrapLabel = false,
  'data-selenium-id': seleniumId
}) => {
  const toggleId = useId();
  return /*#__PURE__*/_jsxs(Clickable, {
    display: "inline-flex",
    alignItems: "center",
    gap: "300",
    minInlineSize: wrapLabel ? '0' : undefined,
    onClick: onToggle,
    "data-selenium-id": seleniumId,
    children: [/*#__PURE__*/_jsx(ScreenReaderOnly, {
      children: /*#__PURE__*/_jsx(FormLabel, {
        htmlFor: toggleId,
        children: ariaLabel
      })
    }), /*#__PURE__*/_jsx("span", {
      onClick: e => e.stopPropagation(),
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0
      },
      children: /*#__PURE__*/_jsx(ToggleUI, {
        id: toggleId,
        enabled: isAnnual,
        onToggleChange: onToggle,
        variant: "rounded-hollow",
        backgroundColor: "fill-primary-default"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      gap: "200",
      alignItems: "center",
      flexWrap: "wrap",
      minInlineSize: wrapLabel ? '0' : undefined,
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-100",
        color: "text-core-default",
        textWrap: wrapLabel ? undefined : 'nowrap',
        children: isAnnual ? labelAnnual : labelMonthly
      }), isAnnual && bestValueLabel && /*#__PURE__*/_jsx(Badge, {
        use: "green",
        borderRadius: "400",
        textWrap: "nowrap",
        borderWidth: "100",
        borderStyle: "solid",
        borderColor: "border-accent-green-default",
        paddingBlock: "50",
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(Text, {
          as: "span",
          typography: "heading-25",
          children: bestValueLabel
        })
      })]
    })]
  });
};